import type {
  ReploProject,
  ReploSimpleProject,
} from "schemas/generated/project";
import type { UserRole } from "schemas/generated/user";
import type { Workspace } from "schemas/generated/workspace";

import { getProjectLabels } from "@v2/utils/project-labels";
import { getProjectName } from "@v2/utils/project-utils";

export type UserWorkspace = {
  workspaceId: string;
  workspaceName: string;
  currentUserRole: UserRole;
  projects: ReploSimpleProject[];
};

export const getProjectDisplayName = (
  workspace: Workspace | UserWorkspace,
  project?: ReploProject,
) => {
  if (project) {
    return getProjectName(project);
  }

  if ("workspaceName" in workspace && workspace.workspaceName) {
    return workspace.workspaceName;
  }

  if ("name" in workspace && workspace.name) {
    return workspace.name;
  }

  return getProjectLabels().singularCapitalized;
};
